export default {"src":"/_next/static/media/home-1.811a36aa.svg","height":980,"width":1440};